import { useMemo } from 'react';

import { useAuthStore } from './auth-store';

/** Case-insensitive lookup — backend slugs aren't consistently cased (e.g. Pos_view vs pos_view). */
function makeHas(permissions: Set<string>) {
  const lower = new Set<string>();
  for (const p of permissions) lower.add(p.toLowerCase());
  return (name: string) => lower.has(name.toLowerCase());
}

export function usePermission(name: string | string[]): boolean {
  const permissions = useAuthStore((s) => s.permissions);
  const has = useMemo(() => makeHas(permissions), [permissions]);
  if (Array.isArray(name)) return name.some(has);
  return has(name);
}

export function useHasAllPermissions(names: string[]): boolean {
  const permissions = useAuthStore((s) => s.permissions);
  const has = useMemo(() => makeHas(permissions), [permissions]);
  return names.every(has);
}
